import type { MediaLink } from '@entities/media';

export function ProductThumb({ link, alt }: { link: MediaLink | undefined; alt: string }) {
  return (
    <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-md border bg-muted">
      {link?.url ? (
        <img src={link.url} alt={alt} className="h-full w-full object-cover" loading="lazy" />
      ) : (
        <span className="text-xs opacity-70">—</span>
      )}
    </div>
  );
}
